export default "__VITE_ASSET__a962f11b__"